<div class="wrapper">
  <div class="parent">
    <div class="left">
      <localization-form-list [reportTemplate]="reportTemplate"
                              [selectedItem]="selectedItem"
                              [reportDesignerLanguageId]="reportDesignerLanguageId"
                              (onWidgetSelection)="onWidgetSelection($event)"></localization-form-list>
    </div>
    <div class="main">
      <localization-form-preview [widget]="widget" [isDefault]="selectedItem?.isDefault"></localization-form-preview>
    </div>
  </div>
</div>
